import { render, staticRenderFns } from "./AccountOrgaIsLiveForm.vue?vue&type=template&id=2858f971&"
import script from "./AccountOrgaIsLiveForm.vue?vue&type=script&lang=ts&"
export * from "./AccountOrgaIsLiveForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports